/**
 * 模块名称: 待结算列表 => 采购订单列表页 => 操作表单
 * @author jiashaowang@372163.com
 */

import React, { useState, useEffect, useRef } from 'react'
import { 
  Form, 
  Input, 
  Upload, 
  Icon, 
  Select,
  DatePicker,
} from 'antd'
import api from '@/api'
import BtnGroup from '@/components/BtnGroup'
import { upLoadModule } from '@/utils/common'
import moment from 'moment'

const FormItem = Form.Item
const TextArea = Input.TextArea
const { Dragger } = Upload
const dateFormat = 'YYYY-MM-DD'

const PurchaseActionsForm = (props) => {
  const { type, values, onSubmit, onCancel, form } = props
  const { getFieldDecorator, setFieldsValue, validateFields } = form
  const draggerRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [fileList, setFileList] = useState([])
  const [payAccounts, setPayAccounts] = useState([])

  useEffect(() => {
    if (values) {
      const { id, payeeBank, payeeAccount } = values
      setFieldsValue(type === 0 ? { id, payeeBank, payeeAccount } : { id })
    }
  }, [type])


  // 付款账号列表（公司账户）
  useEffect(() => {
    const { companyId } = values
    if (type === 1) {
      api.getCorporateAccountlist({ limit: 99999, corpId: companyId }).then((data) => {
        setPayAccounts(Array.isArray(data.list) ? data.list : [])
      }).catch(() => setPayAccounts([]))
    }
  }, [type])

  const onFormSubmit = (e) => {
    e.preventDefault()
    validateFields((err, values) => {
      if (!err) {
        let submitValues = { ...values }
        if (type === 1) {
          const { paymentNumber, payTime, ...restValues } = submitValues
           if (paymentNumber) {
            const [accountNo, bank] = paymentNumber.split('|')
            submitValues = {
              ...restValues,
						  payTime: payTime.format(dateFormat),
              payAccountNo: accountNo || '',
              payBank: bank || '',
            }
          }
          submitValues.certificate = fileList.map((item) => ({
            name: item.name,
            url: item.url,
          }))
        }
        onSubmit(submitValues, setLoading)
      }
    })
  }

  // 文件上传
  const uploadFiles = upLoadModule({
    fileList: fileList,
    setFileList: setFileList,
    draggerRef: draggerRef,
    accept: '.png, .jpg, .PDF',
    allowSizeType: 2,
  })

  const formItemLayout = {
    labelCol: {
      span: 6,
    },
    wrapperCol: {
      span: 18,
    },
  }

  return (
    <Form onSubmit={onFormSubmit} {...formItemLayout}>
      {getFieldDecorator('id', {
        rules: [{ required: true }],
      })(<Input hidden />)}
      <FormItem label='业务编号'>
        <div>{values.id}</div>
      </FormItem>
      <FormItem label='付款金额'>
        <div>{values.payMoney}</div>
      </FormItem>
      {type === 0 ? (
        <>
          <FormItem label='收款单位'>
            <div>{values.payee}</div>
          </FormItem>
          <FormItem label='收款开户行'>
            {getFieldDecorator('payeeBank', {
              rules: [{ required: true, message: '请输入收款开户行' }],
            })(<Input />)}
          </FormItem>
          <FormItem label='银行账号'>
            {getFieldDecorator('payeeAccount', {
              rules: [{ required: true, message: '请输入银行账号' }],
            })(<Input />)}
          </FormItem>
        </>
      ) : (
        <>
          <FormItem label='公司主体'>
            <div>{values.corpName}</div>
          </FormItem>
          <FormItem label='收款单位'>
            <div>{values.payee}</div>
          </FormItem>
          <FormItem label='收款开户行'>
            <div>{values.payeeBank}</div>
          </FormItem>
          <FormItem label='收款账号'>
            <div>{values.payeeAccount}</div>
          </FormItem>
        </>
      )}
      {type === 1 && (
        <>
          <FormItem label="银行支付日期">
            {getFieldDecorator('payTime', {
                initialValue: moment(new Date(), dateFormat),
                rules: [{ required: true, message: '请输入银行支付日期' }]
            })(
                <DatePicker placeholder="请选择" />
            )}
          </FormItem>
          <FormItem label='付款账号'>
            {getFieldDecorator('paymentNumber', {
              rules: [{ required: true, message: '请选择付款账号' }],
            })(
              <Select
                placeholder='请选择'
                dropdownMatchSelectWidth={false}
                showSearch
                className='pay-account-select'
                optionFilterProp='label'
                allowClear
              >
                {payAccounts.map((item) => (
                  <Select.Option
                    key={item.id}
                    value={`${item.accountNo}|${item.bank}`}
                    label={`${item.accountNo}\n${item.bank}`}
                  >
                    <div>
                      <div>{item.accountNo}</div>
                      <div>{item.bank}</div>
                    </div>
                  </Select.Option>
                ))}
              </Select>
            )}
          </FormItem>
          <FormItem label='付款凭证'>
            <div
              className='dragger-box'
              ref={draggerRef}
              style={{ position: 'relative' }}
            >
              <Dragger {...uploadFiles}>
                <p className='ant-upload-drag-icon'>
                  <Icon type='inbox' />
                </p>
                <p className='ant-upload-text'>点击或将文件拖拽到这里上传</p>
                <p className='ant-upload-hint'>
                  支持扩展名：.png, jpg, .pdf 单个文件大小不超过5M。
                </p>
              </Dragger>
            </div>
          </FormItem>
        </>
      )}
      {type === 2 && (
        <FormItem label='终止原因'>
          {getFieldDecorator('failedReason', {
            rules: [{ required: true, message: '请填写终止原因后确认' }],
          })(<TextArea rows={4} maxLength={100} />)}
        </FormItem>
      )}
      <BtnGroup
        cancelName='取消'
        confirmName='确认'
        loading={loading}
        onConfirm={onFormSubmit}
        onCancel={onCancel}
      />
    </Form>
  )
}

export default Form.create()(PurchaseActionsForm)
